/* eslint-disable react-hooks/use-memo, react-hooks/refs */
import { useCallback, useRef } from 'react'

import { throttle } from 'lodash-es'
import type { DebouncedFunc } from 'lodash-es'

const useThrottle = <T extends (...args: never[]) => unknown>(callback: T, wait?: number): DebouncedFunc<T> => {
  const ref = useRef(callback)
  ref.current = callback

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    throttle((...args: never[]) => ref.current(...args), wait),
    [wait],
  ) as DebouncedFunc<T>
}

export default useThrottle
